import { AdminUserManagementComponent } from './user-management.component';
import { RouterModule, Routes } from '@angular/router';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VmeCommonModule } from '../../../vme-common.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

const routes: Routes = [{ path: '', component: AdminUserManagementComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserManagementRoutingModule {}

@NgModule({
  imports: [
    UserManagementRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [AdminUserManagementComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserManagementModule {}
